module.exports = __webpack_public_path__ + "img/20191012161933164.ca05ba50.jpg";